/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraServiceManagementIncidentManagementConfigurationMappingForSecurityAlert extends models.JiraServiceManagementIncidentManagementConfigurationMapping {
    getFixupPrototypeFunction() { return JiraServiceManagementIncidentManagementConfigurationMappingForSecurityAlert.fixupPrototype; }

    static newInstance(model: Partial<JiraServiceManagementIncidentManagementConfigurationMappingForSecurityAlert>): JiraServiceManagementIncidentManagementConfigurationMappingForSecurityAlert {
        let obj = Object.assign(new JiraServiceManagementIncidentManagementConfigurationMappingForSecurityAlert(), model);
        JiraServiceManagementIncidentManagementConfigurationMappingForSecurityAlert.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraServiceManagementIncidentManagementConfigurationMappingForSecurityAlert>): JiraServiceManagementIncidentManagementConfigurationMappingForSecurityAlert {
        if (!model) return null;
        return JiraServiceManagementIncidentManagementConfigurationMappingForSecurityAlert.newInstance(<JiraServiceManagementIncidentManagementConfigurationMappingForSecurityAlert> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraServiceManagementIncidentManagementConfigurationMappingForSecurityAlert) {
        if (!obj) return;

        models.JiraServiceManagementIncidentManagementConfigurationMappingForSecurityAlert.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraServiceManagementIncidentManagementConfigurationMappingForSecurityAlert): boolean {
        if (models.JiraServiceManagementIncidentManagementConfigurationMapping.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, JiraServiceManagementIncidentManagementConfigurationMappingForSecurityAlert.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Allowed attributes for Security Alerts Description
     */
    value: models.DescriptionAttributeForItsmSecurityAlert;

    value_direct: string;

}
